import { useMemo } from 'react'
import Checkbox from '../Checkbox'
import RadioButton from '../RadioButton'
import Switch from '../Switch'
import Textarea from '../Textarea'
import { InputProps } from './props'
import { StyledInput } from './styles'

const Input = ({ id, ...props }: InputProps) => {
    const generatedId = useMemo(
        () => id ?? `rr-input-${Math.random().toString(36).slice(2)}`,
        [id]
    )
    switch (props.type) {
        case 'textarea':
            return <Textarea {...props} id={generatedId} />
        case 'checkbox':
            return <Checkbox {...props} id={generatedId} />
        case 'radio':
            return <RadioButton {...props} id={generatedId} />
        case 'switch':
            return <Switch {...props} id={generatedId} />
        default:
            return <StyledInput {...props} id={generatedId} />
    }
}

export default Input

export { StyledInput }
